export default {
  init() {

  },
  finalize() {

    if ($('.share-btn-wrap').length > 0) {

      setTimeout(() => {
        // Remove "sharethis" button
        $('.share-btn-wrap .st-btn[data-network="sharethis"]').remove();

        // Add "Copy link" button
        const copiedText = $('.share-btn-wrap').data('copied');
        const copyIcon = $('.share-btn-wrap').data('copy-icon')
        
        const $copyLinkBtn = $(`
          <div class="st-btn copy-link" data-network="copylink">
            <img src="${copyIcon}" aria-label="Copy" />
            <span class="copy-link-tip">${copiedText}</span>
          </div>
        `);

        $copyLinkBtn.appendTo($('.share-btn-wrap .sharethis-inline-share-buttons'));

        $copyLinkBtn.on('click', function() {
          if (!$copyLinkBtn.hasClass('copied')) {
            // Create a dummy DOM element.
            const $dummy = $('<input type="text" value="' + window.location.href + '" />');
            $dummy.appendTo('body');
            $dummy.select();

            document.execCommand('copy');
            $dummy.remove();

            $copyLinkBtn.addClass('copied');

            setTimeout(() => {
              $copyLinkBtn.removeClass('copied');
            }, 1000);
          }
        });
      }, 500);

      $('.share-btn').on('click', function() {
        $(this).parent().toggleClass('open');
      });

    }

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/share.js